import { z } from 'zod/v4';

export const insertOrganizationVendorSchema = z.object({
  vendorId: z.uuid(),
});

export type InsertOrganizationVendor = z.infer<typeof insertOrganizationVendorSchema>;

export const deleteOrganizationVendorSchema = z.object({
  id: z.uuid(),
});

const sortSchema = z
  .string()
  .optional()
  .transform((val) => {
    if (!val) {
      return [{ id: 'ownerVendorName', desc: false }];
    }
    try {
      const parsed = JSON.parse(val);
      const schema = z.array(
        z.object({
          id: z.string(),
          desc: z.boolean(),
        }),
      );
      const result = schema.safeParse(parsed);
      if (!result.success) {
        return [{ id: 'ownerVendorName', desc: false }];
      }
      return result.data;
    } catch {
      return [{ id: 'ownerVendorName', desc: false }];
    }
  });

export const getOrganizationVendorsQuerySchema = z.object({
  search: z.string().optional(),
  ownerIds: z.string().transform((val) => val.split(',').filter(Boolean)).optional(),
  limit: z.coerce.number().min(1).max(100).default(25),
  offset: z.coerce.number().min(0).default(0),
  sort: sortSchema,
});

export type GetOrganizationVendorsQuery = z.infer<typeof getOrganizationVendorsQuerySchema>;
